import { date_fetch_formatter } from "./date-format-utils";
import { getCookie } from "./cookies";
// import {data} from '../data/old_data';

// TODO
//  validate input data

let putRez = async (reservation) => {
    let token = btoa(encodeURI(getCookie('lola-sesh')));
    return await fetch("https://fm6wivz7qcpe3batatlu627iri0lmnbw.lambda-url.us-east-1.on.aws/",
        {
            method: "post",
            body: JSON.stringify(reservation),
            mode: "cors",
            credentials: "include",
            headers: {
                "authorization": `Bearer ${token}`,
                "lola-action": "put-rez",
                "content-type": "text/plain",
            }
        })
        .then((r) => r.json())
        .then(async (json) => {

            if (getCookie('bruce-mode') === "true") {
                return await new Promise((resolve) =>
                    setTimeout(() => resolve({ ok: true, data: json }), Math.random() * 750 + 1500)
                )
            } else {
                return {
                    ok: true,
                    data: json
                };
            }
        })
        .catch(async (err) => {
            console.log(err)
            if (getCookie('bruce-mode') === "true") {
                return await new Promise((resolve) =>
                    setTimeout(() => resolve({ ok: false, data: err }), Math.random() * 750 + 1500)
                )
            } else {
                return {
                    ok: false,
                    data: err
                };
            }
        });
};

const testMode = async (data) => {
    let token = btoa(encodeURI(getCookie('lola-sesh')));

    // get the screen resolution BITCH

    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const pixelRatio = window.devicePixelRatio;
    const canvas = document.createElement("canvas");
    const gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
    let GL_Data = false;
    if (gl) {
        const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
        GL_Data = {
            renderer: debugInfo['UNMASKED_RENDERER_WEBGL'],
            vendor: debugInfo['UNMASKED_VENDOR_WEBGL'],
        }
    }
    console.log(GL_Data);

    return await fetch(`https://fm6wivz7qcpe3batatlu627iri0lmnbw.lambda-url.us-east-1.on.aws/`,
        {
            method: "get",
            mode: "cors",
            credentials: "include",
            headers: {
                "authorization": `Bearer ${token}`,
                // "reservation-date": formattedDate,
                "lola-action": "mode-test",
                "content-type": "text/plain",
                "device-data": JSON.stringify({
                    screenWidth,
                    screenHeight,
                    pixelRatio,
                    GL_Data: GL_Data
                })
            }
        })
        .then(async (r) => {
            // // @ts-ignore
            // let reader: ReadableStreamDefaultReader<object> = r.body.getReader();
            // while (true) {
            // 	let res = await reader.read();
            // 	if (res.done) {
            // 		break;
            // 	} else {
            // 		// @ts-ignore
            // 		console.log(new TextDecoder("utf-8").decode(res.value));
            // 	}
            // }
            return r.json();
        }
        )
        .then(async (json) => {
            console.log(json);
            return {
                ok: true,
                data: json
            };
        })
        .catch(async (err) => {
            console.log(err)
            return {
                ok: false,
                data: err
            };
        });
}

const getTodaysRez = async (date) => {


    // console.log(window.bruceMode);
    let formattedDate = date_fetch_formatter(date);
    let token = btoa(encodeURI(getCookie('lola-sesh')));


    // let theData = data.map(e => {
    //     if (e.hasOwnProperty("time")) {
    //         e['seating'] = e['time'];
    //     }


    //     if (e.hasOwnProperty("notes") === false) {
    //         e['notes'] = " ";
    //     }

    //     if (e.hasOwnProperty("confirmed") === false) {
    //         e['confirmed'] = "false";
    //     }

    //     if (e.hasOwnProperty("repeat") === false) {
    //         e['repeat'] = "true";
    //     }

    //     return e;
    // })

    return await fetch("https://fm6wivz7qcpe3batatlu627iri0lmnbw.lambda-url.us-east-1.on.aws/?test=true",
        {
            method: "get",
            mode: "cors",
            credentials: "include",
            headers: {
                "authorization": `Bearer ${token}`,
                "reservation-date": formattedDate,
                "lola-action": "get-rez",
                "content-type": "text/plain",
            }
        })
        .then(async (r) => {
            // // @ts-ignore
            // let reader: ReadableStreamDefaultReader<object> = r.body.getReader();
            // while (true) {
            // 	let res = await reader.read();
            // 	if (res.done) {
            // 		break;
            // 	} else {
            // 		// @ts-ignore
            // 		console.log(new TextDecoder("utf-8").decode(res.value));
            // 	}
            // }

            return r.json();
        }
        )
        .then(async (json) => {
            if (getCookie('bruce-mode') === "true") {
                return await new Promise((resolve) =>
                    setTimeout(() => resolve({ ok: true, data: json }), Math.random() * 750 + 1500)
                )
            } else {
                return {
                    ok: true,
                    data: json
                };
            }
        })
        .catch(async (err) => {
            console.log(err)
            if (getCookie('bruce-mode') === "true") {
                return await new Promise((resolve) =>
                    setTimeout(() => resolve({ ok: false, data: err }), Math.random() * 750 + 1500)
                )
            } else {
                return {
                    ok: false,
                    data: err
                };
            }
        });
};

const getAppVersion = async () => {
    let token = btoa(encodeURI(getCookie('lola-sesh')));
    return await fetch("https://fm6wivz7qcpe3batatlu627iri0lmnbw.lambda-url.us-east-1.on.aws/",
        {
            method: "get",
            mode: "cors",
            credentials: "include",
            headers: {
                "authorization": `Bearer ${token}`,
                "lola-action": "get-version",
                "content-type": "text/plain",
            }
        })
        .then((r) => {
            return r.json();
        }
        )
        .then(async (json) => {
            return {
                ok: true,
                data: json
            };
        })
        .catch(async (err) => {
            console.log(err)
            return {
                ok: false,
                data: err
            };
        });
};

const deleteRez = async (id, date) => {
    let formattedDate = date_fetch_formatter(date);
    let token = btoa(encodeURI(getCookie('lola-sesh')));
    return await fetch("https://fm6wivz7qcpe3batatlu627iri0lmnbw.lambda-url.us-east-1.on.aws/",
        {
            method: "delete",
            mode: "cors",
            credentials: "include",
            headers: {
                "authorization": `Bearer ${token}`,
                "lola-action": "delete-rez",
                "reservation-id": id,
                "reservation-date": formattedDate,
                "content-type": "text/plain",
            }
        })
        .then(async (r) => {
            // // @ts-ignore
            // let reader: ReadableStreamDefaultReader<object> = r.body.getReader();
            // while (true) {
            // 	let res = await reader.read();
            // 	if (res.done) {
            // 		break;
            // 	} else {
            // 		// @ts-ignore
            // 		console.log(new TextDecoder("utf-8").decode(res.value));
            // 	}
            // }
            return r.json();
        })
        .then(async (json) => {
            if (getCookie('bruce-mode') === "true") {
                return await new Promise((resolve) =>
                    setTimeout(() => resolve({ ok: true, data: json }), Math.random() * 750 + 1500)
                )
            } else {
                return {
                    ok: true,
                    data: json
                };
            }
        })
        .catch(async (err) => {
            console.log(err)
            if (getCookie('bruce-mode') === "true") {
                return await new Promise((resolve) =>
                    setTimeout(() => resolve({ ok: false, data: err }), Math.random() * 750 + 1500)
                )
            } else {
                return {
                    ok: false,
                    data: err
                };
            }
        });
};

export {
    putRez,
    getTodaysRez,
    deleteRez,
    getAppVersion,
    testMode
};
